import '../../containers/NewOrder/NewOrder.scss';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { FaAngleLeft } from 'react-icons/fa';
import { dataActions } from 'reducers';
import store from 'store';
import ButtonComponent from 'components/ButtonComponent';
import { useDevice } from 'lib/hooks/useDevice';

interface CartProps {
    show: boolean;
    close: () => void;
    goToSummary: () => void;
}

const CartReset = (props: CartProps) => {
    const { isDesktop } = useDevice();
    const [clearCart, setClearCart] = useState(false);
    const changeClearCart = () => {
        if (clearCart) setClearCart(false);
        else setClearCart(true);
    };

    useEffect(() => {
        if (!isDesktop) return;

        if (props.show) {
            if (store.getState().data.orders.localCart.productsInLocalCart.length === 0) {
                props.close();
                return;
            }
            window.onscroll = () => { window.scroll(0, 0); };
            window.scroll(0, 0);

            const modal = document.getElementsByClassName('NewOrder-dialog-desktop')[0].getElementsByClassName('modal-content')[0] as (HTMLElement);
            const cartIconRect = document.getElementsByClassName('AssortmentSelection-cartIcon')[0].getBoundingClientRect();

            modal.style.top = `${cartIconRect.top + cartIconRect.height + 15}px`;
            modal.style.left = `${cartIconRect.left + cartIconRect.width - modal.getBoundingClientRect().width}px`;
        } else {
            window.onscroll = () => { };
        }
    }, [props.show]);

    return (
        <>
            <Modal show={clearCart} onHide={changeClearCart} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Uwaga</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ textAlign: 'center' }}>Czy na pewno chcesz usunąć zawartość koszyka?</div>
                    <div className='NewOrder-summaryCancelConfirm-buttons'>
                        <ButtonComponent
                            marginLeft='0'
                            marginRight='0'
                            width='45%'
                            text='TAK'
                            onClick={() => {
                                store.dispatch(dataActions.clearLocalCart());
                                changeClearCart();
                                props.close();
                            }}
                            onHoverAnimation={3}
                        />
                        <ButtonComponent
                            marginLeft='10%'
                            marginRight='0'
                            width='45%'
                            text='NIE'
                            onClick={changeClearCart}
                            onHoverAnimation={3}
                        />
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={props.show} onHide={props.close} dialogClassName={!isDesktop ? 'NewOrder-dialog' : 'NewOrder-dialog-desktop'} backdrop='static'>
                {isDesktop ? (
                    <>
                        <Modal.Header closeButton className='NewOrder-modal-header'>
                            <Modal.Title>Zawartość koszyka</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ paddingTop: '0.5rem' }} className='NewOrder-modal-body'>
                            <div style={{ textAlign: 'center' }}>
                                W koszyku znajdują się produkty pochodzące z wcześniej przygotowanego zamówienia.
                            </div>
                        </Modal.Body>
                    </>
                ) : (
                    <>
                        <Modal.Header>
                            <FaAngleLeft size='40px' onClick={props.close} />
                            <Modal.Title>Zawartość koszyka</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ display: 'flex', padding: '0', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ textAlign: 'center' }}>
                                W koszyku znajdują się produkty pochodzące z wcześniej przygotowanego zamówienia.
                                <br></br>
                                Czy chcesz wyczyścić zawartość koszyka?
                            </div>
                        </Modal.Body>
                    </>
                )}
                <Modal.Footer className='NewOrder-modal-footer'>
                    <ButtonComponent
                        text='KONTYNUUJ'
                        onClick={props.close}
                        marginRight='3px'
                        marginTop='0px'
                        marginBottom='0px'
                        brandColoredButton={false}
                    />
                    <ButtonComponent
                        text='OTWÓRZ PODSUMOWANIE'
                        onClick={() => { props.close(); props.goToSummary(); }}
                        marginLeft='3px'
                        marginTop='0px'
                        marginBottom='0px'
                        variant='blue'
                        brandColoredButton={false}
                    />
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CartReset;
